import api from "./apiClient";

export function getInventory() {
  return api.get("/api/public/inventory");
}

export function getDesignItem() {
  return api.get("/api/public/inventory/design");
}